var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44158 8.92578H23.3442C24.9317 8.92578 26.4542 9.55643 27.5768 10.679C28.6993 11.8015 29.33 13.3241 29.33 14.9116V29.0885C29.33 29.7361 29.0727 30.3571 28.6148 30.815C28.157 31.2729 27.5359 31.5301 26.8884 31.5301H7.98581C6.39828 31.5301 4.87576 30.8995 3.7532 29.7769C2.63065 28.6543 2 27.1318 2 25.5443V11.3674C2 10.7198 2.25724 10.0988 2.71512 9.6409C3.17301 9.18302 3.79403 8.92578 4.44158 8.92578ZM4.52034 11.4461H23.3442C24.2633 11.4461 25.1447 11.8112 25.7946 12.4611C26.4445 13.111 26.8096 13.9925 26.8096 14.9116V29.0098H7.98581C7.06671 29.0098 6.18526 28.6446 5.53536 27.9947C4.88545 27.3448 4.52034 26.4634 4.52034 25.5443V11.4461Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.366 12.0495C37.7545 12.275 37.9936 12.6903 37.9936 13.1395V27.3164C37.9936 27.7656 37.7545 28.1809 37.366 28.4063C36.9775 28.6318 36.4983 28.6334 36.1082 28.4105L27.8384 23.6849C27.2341 23.3396 27.0242 22.5698 27.3695 21.9655C27.7148 21.3613 28.4845 21.1513 29.0888 21.4966L35.4733 25.1449V15.311L29.0888 18.9593C28.4845 19.3046 27.7148 19.0946 27.3695 18.4903C27.0242 17.8861 27.2341 17.1163 27.8384 16.771L36.1082 12.0453C36.4983 11.8225 36.9775 11.8241 37.366 12.0495Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.f16d009b67d2d5324a96863ace4886ab.svg";
export { ForwardRef as ReactComponent };